import { Controller } from '@hotwired/stimulus'

import { Events } from '../constants'

import { target, addClass, removeClass, subscribeEvent, unsubscribeEvent } from '../utils'

export default class extends Controller {

    static targets = [
        'dialog',
        'title',
        'message'
    ]

    static values = {
        show: Number
    }

    showValue = 0

    dialog = () => target(this, 'dialog')

    initialize = () => {

        this.showValue = 0
    }

    connect = () => {

        subscribeEvent(Events.SHOW_LOADING, this.open)
        subscribeEvent(Events.HIDE_LOADING, this.close)
    }

    disconnect = () => {

        unsubscribeEvent(Events.SHOW_LOADING, this.open)
        unsubscribeEvent(Events.HIDE_LOADING, this.close)
    }

    open = () => {

        this.showValue = this.showValue + 1

        if (this.showValue === 1) {

            addClass(this.dialog(), 'is-active')
        }
    }

    close = () => {

        this.showValue = this.showValue - 1

        if (this.showValue === 0) {

            removeClass(this.dialog(), 'is-active')
        }
    }
}
